import { IconButton, InputAdornment, TextField, useColorScheme } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useState } from "react";

interface PasswordInputProps {
  password: string,
  setPassword: React.Dispatch<React.SetStateAction<string>>,
  labelMessage?: string
}

export default function PasswordInput(
  {
    password,
    setPassword,
    labelMessage,
  }
    : PasswordInputProps) {
  const { mode, systemMode } = useColorScheme();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <TextField
      name="password"
      placeholder="••••••••••"
      type={showPassword ? "text" : "password"}
      label={labelMessage}
      sx={{
        ...((mode === 'dark' || systemMode === 'dark') ? {
          '& .MuiOutlinedInput-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #050f02ff inset !important',
          },
        } : {
          '& .MuiOutlinedInput-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #ffffff inset !important',
          },
        }),
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={
                showPassword ? 'hide the password' : 'display the password'
              }
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              edge="end"
              sx={{
                backgroundColor: 'transparent !important',
                margin: 0,
                padding: 0,
                width: '30px',
                height: '30px',
                border: 'none',
                '&:hover': {
                  backgroundColor: '#8585853d !important',
                  borderRadius: '30%',
                },
              }}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
      id="outlined-adornment-password"
      value={password}
      onChange={(e) => {
        setPassword(e.target.value);
      }}
      autoComplete="current-password"
      fullWidth
      variant="outlined"
    />
  )
}